<div class="shipping-delay-message">
    <h-message-block class="shipping-delay-message" [showBackground]="false" [autoAddPadding]="false" [type]="'info'">
        @if (isChina) {
        <ng-container i18n="@@hermes.product.shared.shipping.delay.variable.specific.china">
            If there is no current inventory, this item will be subject to delivery delay. Estimate
            {{ product.shippingDelay?.min }}-{{ product.shippingDelay?.max }} business days after order placed. Hermes
            is entitled to cancel the order and shall not bear any legal responsibilities. Customer service team will
            contact you to cancel the order and get refund. By proceeding to the online transaction, it is considered
            that you have agreed to the above term.
        </ng-container>
        } @else {
        <ng-container i18n="@@hermes.product.shared.shipping.delay.variable">
            This item will have a shipping delay of {{ product.shippingDelay?.min }}-{{ product.shippingDelay?.max }}
            business days.
        </ng-container>
        }
    </h-message-block>
</div>
